import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  TextField,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ReasonAutoComplete from '../ReasonAutoComplete';

const useStyles = makeStyles((theme) => ({
  dialogTitleConatiner: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
  },
  dialogTitleText: {
    color: theme.palette.getContrastText(theme.palette.primary.dark),
    fontSize: theme.typography.h3.fontSize,
  },
  datePickerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
  },
  valueField: {
    width: '100%',
  },
}));

function SupplementReasonDialog({
  reasons,
  isDialogOpen,
  setIsDialogOpen,
  handleApply,
}) {
  const classes = useStyles();

  const [selectedReason, setSelectedReason] = useState();
  const [reasonText, setReasonText] = useState();
  const [isCustom, setIsCustom] = useState();

  useEffect(() => handleSelectionChange(selectedReason), [setSelectedReason]);

  const handleClose = (reason) => {
    if (reason === 'escapeKeyDown' || reason === 'backdropClick') {
      return false;
    }
  };

  function handleCancel() {
    setIsDialogOpen(false);
    setSelectedReason(null);
  }

  function handleOK() {
    handleApply(reasonText);
    setIsDialogOpen(false);
    setSelectedReason(null);
  }

  useEffect(() => handleSelectionChange(handleSelectionChange), [selectedReason]);
  function handleSelectionChange() {
    setIsCustom(selectedReason?.ReasonText == 'Custom');
    setReasonText(selectedReason?.ReasonText == 'Custom' ? '' : selectedReason?.ReasonText);
  }


  return (
    <Dialog
      open={isDialogOpen}
      onClose={(_, reason) => handleClose(reason)}
      aria-labelledby="customDateRangePickerTitle"
      aria-describedby="customDateRangePickerContent"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle
        className={classes.dialogTitleConatiner}
        id="customDateRangePickerTitle"
        data-test="customDateRangePickerTitle"
      >
        <Typography
          className={classes.dialogTitleText}
        >
          Select a Supplement Reason
        </Typography>
      </DialogTitle>
      <DialogContent >
        <Box className={classes.datePickerContainer}>
          {<ReasonAutoComplete reasons={reasons} setSelectedReason={setSelectedReason} selectedReason={selectedReason}/>}
          </Box>
          <Box className={classes.datePickerContainer}>
            {isCustom &&
              <TextField
                className={classes.valueField}
                placeholder='Enter custom reason'
                variant="outlined"
                autoFocus
                value={reasonText}
                onChange={(event) => setReasonText(event.target.value)}
              />
          }
        </Box> 

      </DialogContent>
      <DialogActions
        className={classes.actionsContainer}
      >
        <Button
          id="closeDialogButton"
          color='secondary'
          variant="contained"
          onClick={handleCancel}
        >
          Close
        </Button>
        <Button
          id="closeDialogButton"
          color="primary"
          disabled={!reasonText}
          variant="contained"
          onClick={handleOK}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

SupplementReasonDialog.propTypes = {
  reasons: PropTypes.arrayOf(PropTypes.shape({
    purchaseOrderReasonId: PropTypes.number,
    ReasonText: PropTypes.string,
  })),
  isDialogOpen: PropTypes.bool,
  setIsDialogOpen: PropTypes.func,
  handleCustomDateRangeSave: PropTypes.func,
  setSelectedCharge: PropTypes.func,
  handleApply: PropTypes.func,
  isChargeReadOnly: PropTypes.bool,
  providerCategory: PropTypes.string,
};


export default SupplementReasonDialog;
